<template>
  <RallyNav v-if="!this.$refs.RallyNav"/>
  <div>
    <main :class="[channelSlug, 'index']">
      <ToolBar :options="toolbarOptions" allow-member-filter="true" v-on:perform="perform" />
      <MembersComponent :rally="rally" :channel="channel" ref="memComp"/>
    </main>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";
import {RCS_REPORTS_URL, RMEMS_REPORTS_URL, router} from "../common";
import { findDefaultChannelOfType, getChannelSlug } from "../common";
import {eventBus} from "@/main";
import axios from "axios";
import {userInfo} from "@/common/user-info";
import jwtInterceptor from "@/common/jwt-interceptor-wrapper";
import { accessToken } from "../common/auth-header";
import { Capacitor } from "@capacitor/core";
import { Browser } from "@capacitor/browser";
export default {
  props: ["channel", "rally"],
  computed: {
    ...mapState("memberships", ["membersByRallyId", "membersFilter" ]),
    ...mapState("user", ["usersById"]),
    ...mapState("rallies", ["allRalliesByRallyId"]),

    channelSlug() {
      // Used in place of channel.type.
      return getChannelSlug(this.$route)
    },
    members() {
      return this.membersByRallyId[this.rallyId];
    },
    rallyId() {
      return this.rally.id;
    },
    selectedRally: function() {
      return this.rally;
    },
    toolbarOptions() {
      let options = new Array();

      // Disable console errors for using TRUE and FALSE in examples.
      /* eslint-disable no-constant-condition */

      // Consult rally.privacy
      /*
      not mvp
      if (true) {
        options.push({ click: "foo", icon: "fa-plus-circle", label: "Invite" });
      }
      */
      // Present for everyone
      options.push({ onClick: "openSearch", params: { context: 'members' }, icon: "fa-search", label: "Search" });
      options.push({ onClick: "refreshDir", params: { }, icon: "fa-sync", label: "Refresh" });
      if (this.selectedRally.attributes.editable) {
        options.push({ onClick: "openSettings", params: { context: 'directory' }, icon: "fa-cog", label: "Settings" });
        options.push({ onClick: "downloadList", params: { context:  "Members"}, icon: "fa-download", label: "Download", permission:"writable" });
    }

      //not mvp
      //options.push({ click: "foo", icon: "fa-star", label: "Owner & Admin" });

      // This should only be true for rally admin.
      /*
      not mvp
      if (true) {
        options.push({ click: "foo", icon: "fa-cog", label: "Settings" });
      }
      */
      return options;
    }
  },
  created() {
    eventBus.on('download', () => {
      this.downloadList();
      //alert('here')
    })
  },
  methods: {
    ...mapActions("memberships", ["fetchMembersByRally", "clearMemberState", "setMembersFilter"]),
    log(message) {
      this.$log.debug(message);
    },
    // ToolBar buttons emit perform(<methodName>, <params>); without this
    // dispatcher every toolbar action on this page (Download included) was
    // a silent no-op. Guarded because some emitted handlers (e.g.
    // handleMemberFilterChange) are not implemented on this page.
    perform(method, params) {
      if (typeof this[method] !== "function") {
        this.log("MembersPage.perform: no handler for " + method);
        return;
      }
      params ? this[method](params) : this[method]();
    },
    async downloadList() {
      // format=csv is required: rmems ReportsController#index only responds
      // inside `case params[:format]` and otherwise falls through to an
      // empty 204, which downloaded as a zero-byte file.
      const reportUrl = RMEMS_REPORTS_URL() + "?report_name=member_list&format=csv"
          + "&rally_id="
          + this.rallyId;
      try {
        if (Capacitor.getPlatform() !== 'web') {
          // Anchor-click downloads are inert inside the native webview, so
          // hand the URL to the system browser and let the OS download
          // manager save it — same pattern as downloadFile() in utils.
          // Browser.open can't send headers, so the token rides as a query
          // param; rmems' ReportsController promotes it to the
          // Authorization header (reports-only, see rmems zip).
          await Browser.open({ url: reportUrl + "&access_token=" + accessToken() });
          return;
        }
        const response = await jwtInterceptor({
          url: reportUrl,
          method: 'GET',
          responseType: 'blob',
          headers: { 'Accept': 'text/csv' },
        });
        const url = window.URL.createObjectURL(new Blob([response.data], { type: 'text/csv' }));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', this.rallyId + '_members.csv');
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      } catch (error) {
        console.error('Error downloading file:', error);
        this.$store.dispatch('user/flashFailure', 'Could not download the members list');
      }
    },
    /*handleMemberFilterChange(status) {
      if (status === 'only_friends') {
        this.$refs.memComp.refreshMembers( ['Friend', 'Subscriber'], ["Active"])
      } else if (status == 'admins') {
        this.$refs.memComp.refreshMembers( ['Owner', 'Admin'], ["Active"])
      } else if (status == 'all_members') {
        this.$refs.memComp.refreshMembers( ['Owner', 'Admin', 'Friend', 'Subscriber'], ["Active", "Invited", "Requested"])
      } else if (status == 'all_members_and_declinees') {
        this.$refs.memComp.refreshMembers( ['Owner', 'Admin', 'Friend', 'Subscriber'], ["Active", "Invited", "Declined", "Requested", "Pending"])
      } else if (status == 'declinees') {
        this.$refs.memComp.refreshMembers( ['Owner', 'Admin', 'Friend', 'Subscriber'], ["Declined"])
      } else if (status == 'invitees') {
        this.$refs.memComp.refreshMembers( ['Owner', 'Admin', 'Friend', 'Subscriber'], ["Invited"])
      } else if (status == 'requestees') {
        this.$refs.memComp.refreshMembers( ['Owner', 'Admin', 'Friend', 'Subscriber'], ["Requested"])
      } else if (status == 'pending') {
        this.$refs.memComp.refreshMembers( ['Owner', 'Admin', 'Friend', 'Subscriber'], ["Pending"])
      }
    },*/
    async handleMemberFilterChange(status) {
      await this.setMembersFilter({"membersFilter": status})
      this.$refs.memComp.refreshMembersByStatus()
    },
    refreshDir(){
      this.$refs.memComp.refreshMembers();
    },
  }
};
</script>
